import { Outlet } from 'react-router-dom'

const AppLayout = () => {
    return (
        <div className="h-dvh flex flex-col overflow-hidden bg-gray-50">
        <main className="flex-1 min-h-0 overflow-hidden">
          <Outlet />
        </main>
      </div>
    )
}

export default AppLayout